import { ControlLabel } from 'react-bootstrap';
import React from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { SelectField } from '../../../../../common/components/ReduxFormField';
import {
  Button,
  ButtonBar,
  FormGroupRow,
  HorizontalFormControl,
} from '../../../../../common/components';

import './ManualConversionForm.scss';

const ManualConversionForm = ({
  handleSubmit,
  submitting,
  onManualConversion,
  onCancel,
  oid,
  formValues,
  quoteReference,
  transactionId,
  transactionOptions,
}) => {
  const status = formValues?.meta?.status;
  const isApproved = status === 'APPROVED';
  const hasStatus = !!status;

  const handleUpdate = (values) => {
    return onManualConversion(transactionId, values);
  };

  return (
    <form onSubmit={handleSubmit(handleUpdate)}>
      <FormGroupRow label={'Order Id'} labelSize={4} fieldSize={8}>
        <ControlLabel>{oid}</ControlLabel>
      </FormGroupRow>

      <FormGroupRow label={'Quote Reference'} labelSize={4} fieldSize={8}>
        <ControlLabel>{quoteReference}</ControlLabel>
      </FormGroupRow>

      {!!transactionOptions.length && (
        <FormGroupRow label={'Payment Gateway Transactions'} labelSize={4} fieldSize={8}>
          <Field
            name={'meta.reference'}
            component={SelectField}
            options={transactionOptions}
            isClearable
          />
        </FormGroupRow>
      )}
      <FormGroupRow label={' Order Status'} labelSize={4} fieldSize={8}>
        <Field
          name={'meta.status'}
          component={SelectField}
          options={[
            { label: 'Approved - convert to policy', value: 'APPROVED' },
            { label: 'Declined', value: 'DECLINED' },
            { label: 'Failed', value: 'FAILED' },
          ]}
        />
      </FormGroupRow>

      {isApproved && !transactionOptions.length && (
        <>
          {/*<Alert bsStyle={'info'}>*/}
          {/*  <span className={'manual-conversion-form--info'}>*/}
          {/*    <span className={'manual-conversion-form--info-title'}>*/}
          {/*      Order Id:*/}
          {/*    </span>*/}
          {/*     The payment gateway transaction can be found by searching for the above order id.  Please ensure the information added below matches for the above id*/}
          {/*  </span>*/}
          {/*  <span className={'manual-conversion-form--info'}>*/}
          {/*    <span className={'manual-conversion-form--info-title'}>*/}
          {/*      Transaction Reference:*/}
          {/*    </span>*/}
          {/*  This is the reference that appears under 'Terminal ID in auth msg' on the payment gateway portal*/}
          {/*  </span>*/}
          {/*  <span className={'manual-conversion-form--info'}>*/}
          {/*    <span className={'manual-conversion-form--info-title'}>*/}
          {/*      Approval Cover:*/}
          {/*    </span>*/}
          {/*    This code appears under Approval on the Order details page of the payment gateway portal*/}
          {/*  </span>*/}
          {/*</Alert>*/}
          <Field
            name={'meta.reference'}
            label={<div>Reference</div>}
            component={HorizontalFormControl}
            labelSize={4}
            fieldSize={8}
            showError
          />
        </>
      )}
      <ButtonBar>
        {isApproved && (
          <Button
            bsStyle={'primary'}
            type={'submit'}
            label={'Convert Quote to Policy Using this Transaction'}
            isLoading={submitting}
            className={'pull-right'}
          />
        )}

        {!isApproved && hasStatus && (
          <Button
            bsStyle={'primary'}
            type={'submit'}
            label={'Update Status'}
            isLoading={submitting}
            className={'pull-right'}
          />
        )}
        <Button
          bsStyle={'default'}
          label={'Cancel'}
          className={'pull-right'}
          handleClick={onCancel}
        />
      </ButtonBar>
    </form>
  );
};

const FORM_NAME = 'ManualConversionForm';

export default compose(
  connect((state) => {
    return {
      formValues: getFormValues(FORM_NAME)(state),
    };
  }),
  reduxForm({
    form: FORM_NAME,
  }),
)(ManualConversionForm);
